export default __webpack_public_path__ + "static/media/background.a87d8ad0.svg";